<template>
  <PageLoader :loading="loading">
    <EventPage v-if="event" :event="event" />
  </PageLoader>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import EventPage from "@/components/pages/event";
import jsonLd from "@/services/jsonld/event";
import { useEventCheckoutStore } from "@/stores/event-checkout";
import PageLoader from "@/components/pages/PageLoader";

export default defineComponent({
  components: {
    EventPage,
    PageLoader,
  },
  async setup() {
    definePageMeta({
      // disable sticky in header
      disableHeaderStick: true,
      headerDark: true,
    });

    const store = useEventCheckoutStore();
    const route = useRoute();

    const handle = String(route.params.handle);
    store.handle = handle;

    const { loading, event } = storeToRefs(store);
    // const data = useAsyncData("event:" + handle, () => client.event.find(handle));

    const handle404 = (): never => {
      throw createError({ statusCode: 404, statusMessage: "Event Not Found" });
    };

    onMounted(() => {
      store.fetch(handle).catch(handle404);
    });

    useJsonld(jsonLd(event));

    useSeoMeta({
      title: event.value?.seo_title || event.value?.name,
      ogTitle: event.value?.seo_title || event.value?.name,
      description:
        event.value?.seo_description ||
        event.value?.summary ||
        event.value?.description,
      ogDescription:
        event.value?.seo_description ||
        event.value?.summary ||
        event.value?.description,
      publisher: event.value?.organiser?.name,
      ogImage: event.value?.image?.src,
      twitterCard: "summary_large_image",
    });

    return {
      event,
      loading,
    };
  },
});
</script>
